<template>
  <div class="reward-detail-page">
    <!-- Header -->
    <div class="header">
      <div class="back-btn" @click="back">
        <img :src="backUrl" alt="返回">
      </div>
      <div class="title">{{$t('rewardDetail.title')}}</div>
      <div class="placeholder"></div>
    </div>

    <div class="content-container">
      <!-- Logo and Title Section -->
      <div class="header-section">
        <div class="logo-container">
          <img :src="rocketUrl" alt="CoinOcean" class="rocket-logo">
        </div>
        <div class="title-text">CoinOcean</div>
      </div>

      <!-- Description Section -->
      <div class="description-section">
        <div class="description-text">
          {{$t('rewardDetail.description')}}
        </div>
      </div>

      <!-- Reward Table Section -->
      <div class="table-section">
        <div class="table-container">
          <div class="table-header">
            <div class="header-cell balance">{{$t('rewardDetail.balance')}}</div>
            <div class="header-cell reward">{{$t('rewardDetail.reward')}}</div>
          </div>
          <div class="table-body">
            <div class="table-row" v-for="(item, index) in rewardData" :key="index">
              <div class="table-cell balance">{{item.balance}}</div>
              <div class="table-cell reward">{{item.reward}}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Note Section -->
      <div class="note-section">
        <div class="note-text">
          {{$t('rewardDetail.note')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RewardDetail',
  data() {
    return {
      backUrl: require('../../assets/imgs/icon-back.png'),
      rocketUrl: require('../../assets/imgs/coinspot-v-sml.png'),
      rewardData: [
        { balance: '5000', reward: '388' },
        { balance: '10000', reward: '888' },
        { balance: '20000', reward: '1888' },
        { balance: '50000', reward: '3888' },
        { balance: '100000', reward: '8888' },
        { balance: '200000', reward: '18888' },
        { balance: '500000', reward: '38888' }
      ]
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.reward-detail-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #ffffff;
  overflow-y: auto;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background: rgba(0, 0, 0, 0.3);
    border-bottom: 1px solid #333;

    .back-btn {
      cursor: pointer;
      padding: 8px;

      img {
        width: 20px;
        height: 20px;
        filter: invert(1);
      }
    }

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
    }

    .placeholder {
      width: 36px;
    }
  }

  .content-container {
    padding: 40px 20px;
    max-width: 800px;
    margin: 0 auto;
  }

  .header-section {
    text-align: center;
    margin-bottom: 40px;

    .logo-container {
      margin-bottom: 20px;

      .rocket-logo {
        width: 100px;
        height: 100px;
        object-fit: contain;
        filter: drop-shadow(0 0 20px rgba(255, 215, 0, 0.5));
      }
    }

    .title-text {
      font-size: 48px;
      font-weight: bold;
      color: #FFD700;
      text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);
      letter-spacing: 4px;
    }
  }

  .description-section {
    margin-bottom: 40px;

    .description-text {
      font-size: 18px;
      line-height: 1.8;
      text-align: center;
      color: #ffffff;
      background: rgba(139, 69, 19, 0.8);
      padding: 30px;
      border-radius: 15px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    }
  }

  .table-section {
    margin-bottom: 40px;

    .table-container {
      border: 3px solid #FFD700;
      border-radius: 15px;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.4);
      box-shadow: 0 8px 32px rgba(255, 215, 0, 0.2);

      .table-header {
        background: linear-gradient(90deg, #FFD700 0%, #FFA500 100%);
        color: #000000;
        font-weight: bold;
        font-size: 20px;
        display: flex;

        .header-cell {
          flex: 1;
          padding: 20px;
          text-align: center;
          border-right: 2px solid #000000;

          &:last-child {
            border-right: none;
          }
        }
      }

      .table-body {
        .table-row {
          display: flex;
          border-bottom: 2px solid #FFD700;
          transition: background-color 0.3s ease;

          &:hover {
            background: rgba(255, 215, 0, 0.1);
          }

          &:last-child {
            border-bottom: none;
          }

          .table-cell {
            flex: 1;
            padding: 18px 20px;
            text-align: center;
            font-size: 18px;
            font-weight: 500;
            border-right: 2px solid #FFD700;

            &:last-child {
              border-right: none;
            }

            &.balance {
              color: #ffffff;
            }

            &.reward {
              color: #FFD700;
              font-weight: bold;
            }
          }
        }
      }
    }
  }

  .note-section {
    .note-text {
      font-size: 16px;
      line-height: 1.8;
      color: #cccccc;
      text-align: left;
      padding: 25px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 12px;
      border-left: 6px solid #FFD700;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .reward-detail-page {
    .content-container {
      padding: 20px 15px;
    }

    .header-section {
      .title-text {
        font-size: 36px;
        letter-spacing: 2px;
      }

      .logo-container .rocket-logo {
        width: 80px;
        height: 80px;
      }
    }

    .description-section .description-text {
      font-size: 16px;
      padding: 20px;
    }

    .table-section {
      .table-container {
        .table-header {
          font-size: 16px;

          .header-cell {
            padding: 15px 10px;
          }
        }

        .table-body {
          .table-row {
            .table-cell {
              padding: 15px 10px;
              font-size: 16px;
            }
          }
        }
      }
    }

    .note-section .note-text {
      font-size: 14px;
      padding: 20px;
    }
  }
}
</style>
